export const FlowType = {
  ONBOARDING: 'Onboarding',
  REGISTRATION: 'Registration',
};
